import { createAction } from "@reduxjs/toolkit";

enum ApplicationVersionActionTypes {
    GET = "[APPLICATIONVERSION] GET",
}
export const applicationVersionGetActionCreator = createAction<{callback: (version: string) => void}>(ApplicationVersionActionTypes.GET);
